import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ph from "../img/icon/ph.png";
import mail from "../img/icon/mail.png";
import loc from "../img/icon/loc.png";
import "../../styles/components-styles/Reachout.css";
import { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

const ReachOut = () => {
  const [program, setProgram] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://hrishisholistichub.com/sendEmailv2.php",
        data, {
          headers: {
            'Content-Type': 'application/json', // Make sure you're sending JSON
          }
        }
      );
      if (response.data.success) {
        setSuccessMessage("Your message has been sent successfully!");
        setErrorMessage("");
      } else {
        setErrorMessage(
          "There was an error sending your message. Please try again."
        );
        setSuccessMessage("");
      }
    } catch (error) {
      setErrorMessage(
        "There was an error sending your message. Please try again."
      );
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="contact-form-container">
      <Box className="contact-form-box">
        <Box className="form-content">
          <Box className="form-section">
            <Typography className="form-title">Enquire Now</Typography>
            <form onSubmit={handleSubmit(onSubmit)}>

            <TextField
              label="Your name"
              variant="standard"
              fullWidth
              className="input-field"
              {...register("fullName", {
                required: "Full Name is required",
              })}
              error={!!errors.fullName}
              helperText={errors.fullName?.message}
            />
            <TextField
              label="Email"
              variant="standard"
              fullWidth
              className="input-field"
              {...register("email", {
                required: "Email is required",
                pattern: /^\S+@\S+\.\S+$/i,
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
            <TextField
              label="Mobile"
              variant="standard"
              fullWidth
              className="input-field"
              {...register("contact", {
                required: "Contact number is required",
              })}
              error={!!errors.contact}
              helperText={errors.contact?.message}
            />
            <Button
              variant="contained"
              className="submit-button"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                "Submit"
              )}
            </Button>
            {successMessage && (
              <Typography
                variant="body1"
                color="green"
                sx={{ marginBottom: "10px" }}
              >
                {successMessage}
              </Typography>
            )}
            {errorMessage && (
              <Typography
                variant="body1"
                color="red"
                sx={{ marginBottom: "10px" }}
              >
                {errorMessage}
              </Typography>
            )}
            </form>
          </Box>

          <Box className="divider"></Box>

          <Box className="contact-info">
            <Typography className="form-title">Reach Out To Us</Typography>
            <Box className="contact-info-item">
              <img src={ph} alt="Phone" className="contact-info-icon" />
              <Typography>+91 8766551964</Typography>
            </Box>
            <Box className="contact-info-item">
              <img src={loc} alt="Location" className="contact-info-icon" />
              <Typography>Branches in Pune and New Delhi</Typography>
            </Box>
            <Box className="contact-info-item">
              <img src={mail} alt="Email" className="contact-info-icon" />
              <Typography>contact@hrishisholistichub.com</Typography>
            </Box>
          </Box>
        </Box>

        {/* <TextField
          select
          label={program ? "" : "Select Your Program"} // Hide label when selected
          fullWidth
          className="select-program"
          value={program}
          onChange={(e) => setProgram(e.target.value)}
          InputLabelProps={{ shrink: false }}
          variant="outlined" // Ensures consistent UI
        >
          <MenuItem value="program1">Program 1</MenuItem>
          <MenuItem value="program2">Program 2</MenuItem>
          <MenuItem value="program3">Program 3</MenuItem>
        </TextField> */}
      </Box>
    </Box>
  );
};

export default ReachOut;
